<template>
  <div class="report-filter report-dates">
    <div class="ms-help">Период:</div>
    <div class="report-dates-input">
      <date-picker
        :type="pickerOptions.type"
        style="width: 160px"
        :format="pickerOptions.format"
        v-model="startDate"
        :options="startDateOptions"
        :clearable="false"
      />
      <span class="ms-help"> - </span>
      <date-picker
        :type="pickerOptions.type"
        style="width: 160px"
        :format="pickerOptions.format"
        v-model="endDate"
        :options="
          $route.params.id === 'new_report_1' ? endYearOptions : endDateOptions
        "
        @on-change="onEndDateChange"
        :clearable="false"
      />
    </div>
  </div>
</template>

<script>
import { getLastDayOfMonth } from '@/utils'

export default {
  data () {
    return {
      startDateOptions: {
        disabledDate: (date) => {
          const start = this.endDate

          return date && date.valueOf() > start.valueOf()
        }
      },
      endDateOptions: {
        disabledDate: (date) => {
          const start = this.startDate
          const oneDayValue = 24 * 60 * 60 * 1000

          return date && date.valueOf() < start.valueOf() - oneDayValue
        }
      },
      endYearOptions: {
        disabledDate: (date) => {
          const start = this.startDate

          return date && date.getFullYear() < start.getFullYear()
        }
      }
    }
  },
  watch: {
    '$route.params.id': {
      handler (value) {
        let endDateValue
        const futureDate = new Date()
        futureDate.setFullYear(futureDate.getFullYear() + 10)

        switch (value) {
          case 'report_2':
          case 'report_3':
            endDateValue = futureDate
            break
          default:
            endDateValue = getLastDayOfMonth(new Date())
        }

        this.$store.commit('SET_REPORTS_VALUE', {
          field: 'endDate',
          value: endDateValue
        })
      },
      immediate: true
    }
  },
  computed: {
    startDate: {
      get () {
        return this.$store.state.reports.startDate
      },
      set (value) {
        this.$store.commit('SET_REPORTS_VALUE', {
          field: 'startDate',
          value
        })
      }
    },
    endDate: {
      get () {
        return this.$store.state.reports.endDate
      },
      set (value) {
        this.$store.commit('SET_REPORTS_VALUE', {
          field: 'endDate',
          value
        })
      }
    },
    pickerOptions () {
      const { id } = this.$route.params

      switch (id) {
        case 'new_report_1':
          return {
            type: 'year',
            format: 'yyyy'
          }
        case 'signed_project_report':
          return {
            type: 'date',
            format: 'dd.MM.yyyy'
          }

        default:
          return {
            type: 'month',
            format: 'dd.MM.yyyy'
          }
      }
    }
  },
  methods: {
    onEndDateChange (value) {
      const { id } = this.$route.params
      if (id !== 'signed_project_report' && id !== 'new_report_1') {
        const dateArr = value.split('.')

        this.endDate = getLastDayOfMonth(
          new Date(dateArr[2], dateArr[1] - 1, dateArr[0])
        )
      }
    }
  }
}
</script>

<style lang="less">
.report-dates {
  display: flex;
  align-items: center;

  &-input {
    margin-left: 8px;

    .ms-help {
      margin: 0 4px;
    }
  }
}
</style>
